import { render, staticRenderFns } from "./DMVFees.vue?vue&type=template&id=5943ee3f"
import script from "./DMVFees.vue?vue&type=script&lang=js"
export * from "./DMVFees.vue?vue&type=script&lang=js"
import style0 from "./DMVFees.vue?vue&type=style&index=0&id=5943ee3f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/DMVFees.vue
// module id = null
// module chunks = 